import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiurl } from "@/Config/ApiConfig/ApiUrl";

export const emailOtpApi = createApi({
  reducerPath: "emailOtpApi",
  baseQuery: fetchBaseQuery({ baseUrl: import.meta.env.VITE_BASE_API_URL }),
  tagTypes: ["EmailOtp"],
  endpoints: (builder) => ({
    emailOtp: builder.mutation({
      query: ({ otp, otpType, userId }) => ({
        url: apiurl.VerifyOTP,
        method: "POST",
        body: { otp, otpType, userId },
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
      }),
      invalidatesTags: ["EmailOtp"],
    }),
  }),
});
export const { useEmailOtpMutation } = emailOtpApi;